export default __webpack_public_path__ + "static/media/remove.603b7708.png";